import type { EliminationBoundary, SpaceConfig } from "../types/space";

export function getEliminationBoundary(
  config: SpaceConfig,
): EliminationBoundary {
  return {
    centerX: config.centerX,
    centerY: config.centerY,
    radius: config.radius + config.boundaryPadding,
  };
}

export function isOutOfBounds(
  x: number,
  y: number,
  boundary: EliminationBoundary,
): boolean {
  const dx = x - boundary.centerX;
  const dy = y - boundary.centerY;
  return dx * dx + dy * dy > boundary.radius * boundary.radius;
}
